import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme, { expandAbsolutely } from '../styles/theme';
import Title from './Title';

const TopicTitle = ({ className, classes, ...rest }) => (
  <Title className={cn(className, classes.title)} {...rest} />
);

TopicTitle.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
};

TopicTitle.defaultProps = {
  className: undefined,
};

export default injectSheet({
  title: {
    textTransform: 'uppercase',
    fontFamily: theme.fonts.bold,
    fontWeight: theme.fonts.boldWeight,
    color: theme.colors.brandBlack,
    fontSize: 16,
    margin: [0, 0, 5],
    letterSpacing: 2.3,
    paddingLeft: 12,
    position: 'relative',
    '&::before': {
      ...expandAbsolutely,
      content: '""',
      bottom: 5,
      borderLeft: `3px solid ${theme.colors.brandBlack}`,
    },
  },
})(TopicTitle);
